import { render, staticRenderFns } from "./VerGrupos.vue?vue&type=template&id=37eca292"
import script from "./VerGrupos.vue?vue&type=script&lang=js"
export * from "./VerGrupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports